import { AxiosInstance } from "axios"
import { CardSubscription, DetailedPriceList, PriceListCreate } from "./priceListTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum PriceListQuery {
    LIST = "price-lists-for-merchant",
    DETAILS = "details-for-price-list",
    CARD_SUBSCRIPTIONS = "card-subscriptions",
}

export type PriceListType = {
    id: number
    name: string
    isActive: boolean
}

type FetchPriceListsParam = Readonly<{
    merchantId: number
    includeProducts?: boolean
}>

export type FetchPriceListsResponse = {
    priceLists: PriceListType[]
}

export async function fetchPriceLists(
    { merchantId, includeProducts }: FetchPriceListsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchPriceListsResponse> {
    const url = `/merchants/${merchantId}/priceLists`

    const response = await axios.get(url, {
        params: {
            merchantId,
            includeProducts,
        },
        signal,
    })

    return response.data
}

type FetchDetailedPriceListsParam = Readonly<{
    id: number
}>

export type FetchDetailedPriceListsResponse = {
    priceList: DetailedPriceList
}

export async function fetchDetailedPriceLists(
    params: FetchDetailedPriceListsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchDetailedPriceListsResponse> {
    const { id } = params
    const url = `/priceLists/${id}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

type DeletePriceListParam = Readonly<{
    id: number
}>

type DeletePriceListResponse = Readonly<{}>

export async function deletePriceList(
    params: DeletePriceListParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeletePriceListResponse> {
    const { id } = params
    const url = `/priceLists/${id}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}

export async function createPriceList(
    priceList: PriceListCreate,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/priceLists"

    const response = await axios.post(
        url,
        {
            priceList,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function updatePriceList(
    { priceList, priceListId }: { priceList: PriceListCreate; priceListId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/priceLists/${priceListId}`

    const response = await axios.post(
        url,
        {
            priceList,
        },
        {
            signal,
        },
    )

    return response.data
}

type FetchIdCardsSubscriptionTypeParam = Readonly<{
    merchantId: number
}>

export type FetchIdCardsSubscriptionTypeResponse = {
    cardSubscriptions: Array<CardSubscription>
}

export async function fetchIdCardsSubscriptionType(
    { merchantId }: FetchIdCardsSubscriptionTypeParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchIdCardsSubscriptionTypeResponse> {
    const url = `/merchants/${merchantId}/userCards/subscriptionTypes`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}
